import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoMobile, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          pv="5px"
          bg="rgba(0, 0, 0, 0.8)"
          boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25)"
          h="50px"
        >
          <CFView row center mt="15px">
            <CFImage w="95%" src={logo} alt="MaguroGuy Logo" />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          w="100%"
          zIndex={98}
          bg="rgba(0, 0, 0, 0.85)"
          boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25)"
          h="50px"
        >
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFImage
              mt="12px"
              ml="50px"
              h="55px"
              src={logo}
              alt="MaguroGuy Logo"
              zIndex={98}
            />
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
